import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import GradientOverflowContainer from "shared/components/GradientOverflowContainer";

import "./PickOneButton.scss";

const PickOneButton = (props) => {
	const {
		gradientOverflow,
		choices,
		value,
		onChange,
		classRoot,
		disabled,
		unselectedButtonClass,
		selectedButtonClass,
	} = props;

	const componentClasses = classnames({
		"pickonebutton": true,
		[`${classRoot}-pickonebutton`]: true,
	});

	const containerClasses = classnames({
		"pickonebutton-container": !gradientOverflow,
		[`${classRoot}-pickonebutton-container`]: true,
	});

	const buttonsClasses = classnames({
		"pickonebutton-buttons": true,
		[`${classRoot}-pickonebutton-buttons`]: true,
	});

	const getButtonClasses = (choiceName) => {
		const isSelected = choiceName !== undefined && choiceName === value;

		return classnames({
			"pickonebutton-button": true,
			[`${classRoot}-pickonebutton-button`]: true,
			"pickonebutton-button--selected": isSelected,
			[`${classRoot}-pickonebutton-button--selected`]: isSelected,
			[`${unselectedButtonClass}`]: unselectedButtonClass && !isSelected,
			[`${selectedButtonClass}`]: selectedButtonClass && isSelected,
		});
	};

	const changeChoice = (choice) => {
		if (onChange) {
			return () => {
				onChange(choice);
			};
		}

		return undefined;
	};

	const Container = gradientOverflow ? GradientOverflowContainer : "div";

	return (
		<div className={componentClasses}>
			<Container className={containerClasses}>
				<div className={buttonsClasses}>
					{choices && choices.map((choice) => (
						<button
							key={choice.key || choice.name}
							className={getButtonClasses(choice.value)}
							onClick={changeChoice(choice.value)}
							disabled={disabled}
						>
							{choice.name}
						</button>
					))}
				</div>
			</Container>
		</div>
	);
};

PickOneButton.propTypes = {
	gradientOverflow: PropTypes.bool,
	choices: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.node,
		value: PropTypes.any.isRequired,
	})),
	value: PropTypes.any,
	onChange: PropTypes.func.isRequired,
	classRoot: PropTypes.string.isRequired,
	unselectedButtonClass: PropTypes.string,
	selectedButtonClass: PropTypes.string,
	disabled: PropTypes.bool,
};

PickOneButton.defaultProps = {
	gradientOverflow: false,
	disabled: false,
};

export default PickOneButton;



// WEBPACK FOOTER //
// ./src/shared/components/PickOneButton.jsx